import proyecto from "../../api/Proyecto";

export const getUnidadesMedida = async () => {
  const response = await proyecto.get("/productos/unidades");
  return response.data;
};

export const getTiposPrecio = async () => {
  const response = await proyecto.get("/productos/tipos-precio");
  return response.data;
};

export const insertarProducto = async (producto) => {
  const response = await proyecto.post("/productos", producto);
  return response.data;
};
export const getProductos = async () => {
  const response = await proyecto.get("/productos");
  return response.data;
};
export const getProductosPaged = async ({ q = "", page = 0, pageSize = 10, id_categoria = "", id_marca = "" } = {}) => {
  const response = await proyecto.get("/productos", {
    params: { q, page, pageSize, id_categoria, id_marca }
  });
  return response.data; // { items, total }
};

export const uploadProductoImagen = async (file) => {
  const formData = new FormData();
  formData.append("imagen", file);
  const response = await proyecto.post("/productos/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const eliminarProducto = async (id) => {
  const response = await proyecto.delete(`/productos/${id}`);
  return response.data;
};

export const lookupProductos = async ({ codigos = [], codigos_barras = [] } = {}) => {
  const response = await proyecto.post("/productos/lookup", { codigos, codigos_barras });
  return response.data;
};
